export class DbFile {
  id?: number;
  name?: string;
  content?: string;
}
